import React, { useState } from 'react';
import Sidebar from './Sidebar';
import PatientBanner from './PatientBanner';

function AppLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main style={{
        flex: 1,
        marginLeft: collapsed ? '64px' : '220px',
        transition: 'margin-left 0.2s ease',
        backgroundColor: '#f9fafb',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <PatientBanner />
        <div style={{ flex: 1 }}>
          {children}
        </div>
      </main>
    </div>
  );
}

export default AppLayout;
